import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Contacts from './Contacts';
import Sidebar from './components/Sidebar';
import GroupManager from './components/GroupManager';
import './ContactsPage.css';

function ContactsPage() {
  const navigate = useNavigate();
  const [selectedPhone, setSelectedPhone] = useState('');
  const [contacts, setContacts] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSelectContact = (phoneNumber) => {
    setSelectedPhone(phoneNumber);
    // Navigate back to home with phone number
    navigate('/messages', { state: { phoneNumber } });
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleGroupCreated = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="contacts-page" style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar onLogout={handleLogout} />
      <div className="contacts-page-container" style={{ 
        marginLeft: '260px', 
        width: 'calc(100% - 260px)',
        transition: 'all 0.3s ease',
        flex: 1,
        minHeight: '100vh',
        padding: '20px'
      }}>
        <div className="contacts-page-header">
          <h1>📇 Manage Contacts</h1>
        </div>
        
        <GroupManager 
          contacts={contacts}
          onGroupCreated={handleGroupCreated}
        />
        
        <Contacts 
          key={refreshKey}
          onSelectContact={handleSelectContact}
          showSelectButton={true}
          onContactsLoaded={setContacts}
        />
      </div>
    </div>
  );
}

export default ContactsPage;

